import { apiRequest } from './client';
import type { UnknownAtsHostRoll } from '@outlinked/shared';

// Re-export canonical type so consumers import from this file rather than
// reaching into @outlinked/shared directly (mirrors the pattern in runs.ts).
export type { UnknownAtsHostRoll };

export interface UnknownAtsHostsListResponse {
  items: UnknownAtsHostRoll[];
  nextCursor: string | null;
}

export function listUnknownAtsHosts(
  opts: { cursor?: string; limit?: number } = {},
): Promise<UnknownAtsHostsListResponse> {
  const params = new URLSearchParams();
  if (opts.cursor) params.set('cursor', opts.cursor);
  if (opts.limit) params.set('limit', String(opts.limit));
  return apiRequest<UnknownAtsHostsListResponse>(`/unknown-ats-hosts?${params}`);
}
